import React, { useState } from 'react';
import './SourceCitation.css';

const SourceCitation = ({ sources }) => {
  const [expanded, setExpanded] = useState(false);

  if (!sources || sources.length === 0) return null;

  return (
    <div className="source-citation">
      <button 
        className="citation-toggle"
        onClick={() => setExpanded(!expanded)}
      >
        <span className="citation-icon">📚</span>
        <span className="citation-text">
          {sources.length} source{sources.length > 1 ? 's' : ''} referenced
        </span>
        <span className={`citation-arrow ${expanded ? 'expanded' : ''}`}>
          ▼
        </span>
      </button>

      {expanded && (
        <div className="citation-list">
          {sources.map((source, index) => (
            <div key={index} className="citation-item">
              <div className="citation-number">{index + 1}</div>
              <div className="citation-content">
                <div className="citation-document">
                  <span className="doc-icon">📄</span>
                  <span className="doc-name">{source.document_name}</span>
                </div>
                {source.page && (
                  <div className="citation-page">Page {source.page}</div>
                )}
                {source.excerpt && (
                  <div className="citation-excerpt">
                    "{source.excerpt}"
                  </div>
                )}
                {source.relevance_score && (
                  <div className="citation-relevance">
                    Relevance: {Math.round(source.relevance_score * 100)}%
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SourceCitation;
